import {
	GET_PRICE,
	SELECT_SERVICE,
	ASYNC_START,
	ADD_WORKER,
	REMOVE_WORKER,
	ADD_TECHNICAL_WORKER,
	REMOVE_TECHNICAL_WORKER,
	ADD_SET_WORKER,
	REMOVE_SET_WORKER,
	ADD_PACKING_WORKER,
	REMOVE_PACKING_WORKER,
	ADD_EXPENSIVE_ITEM,
	SET_TIME,
	SET_DATE,
	SET_TIMESTAMP,
	PLUS_HOUR,
	MINUS_HOUR,
	PLUS_MINUTE,
	MINUS_MINUTE,
	ORIGIN_LOCATION_SELECTED,
	DESTINATION_LOCATION_SELECTED,
	RESET_DESTINATION,
	CHANGE_ORIGIN_ADDRESS,
	CHANGE_DESTINATION_ADDRESS,
	PLUS_ORIGIN_FLOOR,
	MINUS_ORIGIN_FLOOR,
	MINUS_DESTINATION_FLOOR,
	PLUS_DESTINATION_FLOOR,
	UPDATE_ORIGIN_LATLNG,
	UPDATE_DESTINATION_LATLNG,
	HIDE_ERROR_ALERT,
	SHOW_ERROR_ALERT,
	CHANGE_COUPON,
	CHECK_COUPON,
	SHOW_SUCCESS_ALERT,
	HIDE_SUCCESS_ALERT,
	SHOW_ORDER_ALERT,
	SHOW_PHONE_ALERT,
	CHANGE_RECEIVER_NAME,
	CHANGE_RECEIVER_LAST_NAME,
	CHANGE_RECEIVER_PHONE,
	HIDE_PHONE_ALERT,
	HIDE_ORDER_ALERT,
	VERIFICATION_CODE_SENT,
	SEND_ORDER,
	SET_USER_ID,
	GET_ORDER,
	GET_BILL,
	REMOVE_INVOICE,
	STRINGIFY_SHIT,
	RESET_STATE,
	CHANGE_ORIGIN_BUILDING_NUM,
	CHANGE_DEST_BUILDING_NUM,
	HANDLE_BUILDING_NUMS,
	INVOICE_PAYED,
	WRONG_COUPON,
	PREPARE_ORDER,
	SET_DISCOUNT_CHANGES,
	SUBMIT_ORDER,
	ORDER_CANCELED,
	ASYNC_END,
	COPY_RECEIVER_NAME,
	SHOW_WARNING_ALERT,
	HIDE_WARNING_ALERT,
	RESET_RECEIVER,
	CHANGE_ORIGIN_FLOOR,
	CHANGE_DEST_FLOOR,
	TOGGLE_ELEVATOR_DEST,
	TOGGLE_ELEVATOR_ORIGIN,
	CHANGE_RECEIVER_DISPLAY,
	RETRIEVE_INVOICE_LIST,
	REMOVE_INVOICE_LIST,
	IS_SELECTING_LOCATION,
	LOCATION_SELECTED,
	SET_ORDER_ID,
	SET_SERVICE_STATUS,
	SET_MORE_SERVICES_ORDER,
	START_CHECKING_FOR_COMMENT,
	END_CHECKING_FOR_COMMENT,
	REMOVE_EXPENSIVE_ITEM,
	SET_EDITING_ORDER,
	SET_SEARCH_PLACE_RESULT,
	SET_DRIVER,
	SEARCH_SELECTED,
	INCREASE_STOP_TIME,
	DECREASE_STOP_TIME,
	SET_ADDRESSES,
	ASYNC_COUPON_START,
	ASYNC_COUPON_END,
	SET_TIMING,
	SET_HOURS,
	PREORDERING_PROGRESS_START,
	PREORDERING_PROGRESS_END,
	SUBMIT_ORDER_AFTER_ALL,
	SUBMITTING_ORDER,
	SET_MARKETING_TOKEN,
	CHANGE_ORDER_DESCRIPTION,
	OPEN_DRAWER_MENU,
	CLOSE_DRAWER_MENU,
	SHOW_BACK_BTN,
	HIDE_BACK_BTN,
	SET_CANCEL_REASON_TEXT,
	SET_CANCEL_TEXTAREA,
	SET_SHOW_TIME_CARD,
	STORE_HEAVY_ITEMS,
	HIDE_HEADER,
	CHANGE_AREA_VALUE,
	INCREASE_WALKING,
	DECREASE_WALKING,
	SET_WORKER_VALUE,
	SET_PRICE_SUBMIT_BUTTON,
	SET_PRICE_SUBMIT_BUTTON_ID,
} from "../actions/actionsTypes"
import i18n from "../i18nextInitiator"
import {hasExpensive, orderingConfigValues} from "../actions/actionCreators"

/**
 * The Specific translate funciton for this namespace
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "orderReducer")

const persianDate = require("persian-date")
/**
 * Get the persisted state from local storage
 * @returns {any|undefined}
 */
const persistedState = () => {
	try {
		const serializedState = localStorage.getItem("state")
		if (serializedState === null) {
			return undefined
		} else {
			return JSON.parse(serializedState)
		}
	} catch (e) {
		return undefined
	}
}
const initialState = {
	price: 0,
	activeService: "nissan",
	time: {
		hour: "12",
		minute: "00",
	},
	originMarkerDraggable: true,
	destinationMarkerDraggable: true,
	destinationMarkerOpacity: 0,
	ErrorAlert: false,
	receiverName: "",
	receiverLastName: "",
	authCode: "",
	originBuildingNum: "",
	destBuildingNum: "",
	map: {
		center: {
			lat: 35.700944,
			lng: 51.391151,
		},
		marker: {
			lat: 35.700944,
			lng: 51.391151,
		},
		markerTo: {
			lat: 35.700944,
			lng: 51.4,
		},
		zoom: 13,
	},
	showReceiver: "none",
	invoiceListCurrentPage: 1,
	popover: t("popovers.default"),
	openDrawerMenu: false,
	order: {
		car_id: 2,
		barbar_worker: 0,
		chideman_worker: 0,
		tech_worker: 0,
		layout_worker: 0,
		origin_floor: 0,
		destination_floor: 0,
		origin_walking: 0,
		destination_walking: 0,
		vasayeleHazinedar: [],
		platform: "webapp",
		asansor_dest: false,
		asansor_origin: false,
		metraj: 0,
		stop_inway: 0,
	},
	priceButtons: [],
}
/**
 * current state. if does not exist, use the initial state.
 */
const currentState = persistedState() ?? initialState

export default (state = currentState, action) => {
	switch (action.type) {
		case GET_PRICE:
			const price = (action.payload * Math.pow(10, -1))
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			return {
				...state,
				price: price,
				inProgress: false,
			}

		case SELECT_SERVICE:
			return {
				...state,
				popover: t("popovers.default"),
				order: {
					...state.order,
					car_id: action.number,
					barbar_worker: action.barbar_worker,
				},
			}

		case ASYNC_START:
			return {...state, inProgress: true}
		case ASYNC_END:
			return {...state, inProgress: false}

		case ADD_WORKER:
			return {
				...state,
				order: {...state.order, barbar_worker: state.order.barbar_worker + 1},
			}
		case REMOVE_WORKER:
			return {
				...state,
				order: {...state.order, barbar_worker: state.order.barbar_worker - 1},
			}

		case ADD_TECHNICAL_WORKER:
			return {
				...state,
				popover: t("popovers.technical-worker"),
				order: {...state.order, tech_worker: state.order.tech_worker + 1},
			}
		case REMOVE_TECHNICAL_WORKER:
			return {
				...state,
				order: {...state.order, tech_worker: state.order.tech_worker - 1},
			}

		case ADD_SET_WORKER:
			return {
				...state,
				popover: t("popovers.set-worker"),
				order: {...state.order, layout_worker: state.order.layout_worker + 1},
			}
		case REMOVE_SET_WORKER:
			return {
				...state,
				order: {...state.order, layout_worker: state.order.layout_worker - 1},
			}

		case ADD_PACKING_WORKER:
			return {
				...state,
				popover: t("popovers.packing-worker"),
				order: {
					...state.order,
					chideman_worker: state.order.chideman_worker + 1,
				},
			}
		case REMOVE_PACKING_WORKER:
			return {
				...state,
				order: {
					...state.order,
					chideman_worker: state.order.chideman_worker - 1,
				},
			}

		case ADD_EXPENSIVE_ITEM:
			var arr = state.order.vasayeleHazinedar
			state.order.vasayeleHazinedar.map((obj) => {
				if (obj.id === action.number) {
					arr = state.order.vasayeleHazinedar.filter(
						(object) => object.id !== action.number,
					)
					arr = [
						...arr,
						{...obj, id: action.number, count: (obj.count ?? 0) + 1},
					]
				}
			})

			var barbar_worker
			if (state.order.car_id === orderingConfigValues.truckServiceNumber)
				barbar_worker =
					state.order.barbar_worker < orderingConfigValues.minWorker
						? orderingConfigValues.minWorker
						: state.order.barbar_worker
			else
				barbar_worker =
					state.order.barbar_worker < orderingConfigValues.smallTruckMinWorker
						? orderingConfigValues.smallTruckMinWorker
						: state.order.barbar_worker

			return {
				...state,
				order: {...state.order, vasayeleHazinedar: arr, barbar_worker},
			}

		case REMOVE_EXPENSIVE_ITEM:
			var arr
			state.order.vasayeleHazinedar.map((obj) => {
				if (obj.id === action.number && obj.count && obj.count !== 0) {
					arr = state.order.vasayeleHazinedar.filter(
						(object) => object.id !== action.number,
					)
					arr = [...arr, {...obj, id: action.number, count: obj.count - 1}]
				}
			})

			return {
				...state,
				order: {
					...state.order,
					vasayeleHazinedar: arr ?? [...state.order.vasayeleHazinedar],
				},
			}

		case SET_TIME:
			return {...state, time: action.time}

		case SET_DATE:
			return {...state, date: action.date}

		case SET_TIMESTAMP:
			if (action.time)
				return {...state, order: {...state.order, time: action.time}}
			else
				return {
					...state,
					order: {
						...state.order,
						time: new persianDate([
							state.date.year,
							state.date.month,
							state.date.day,
							state.time.hour,
							state.time.minute,
						]).unix(),
					},
				}

		case PLUS_HOUR:
			var h = ("0" + (Number(state.time.hour) + 1)).slice(-2)
			if (h == 24) h = "00"
			var now = new persianDate()
			if (
				now.hour() > h &&
				now.date() == state.date.day &&
				now.month() == state.date.month &&
				now.year() == state.date.year
			) {
				h = now.hour()
			}
			return {
				...state,
				time: {...state.time, hour: h},
				priceGetter: action.priceGetter,
			}

		case MINUS_HOUR:
			var h = ("0" + (Number(state.time.hour) - 1)).slice(-2)
			if (h == "-1") h = "23"

			var now = new persianDate()
			if (
				now.hour() > h &&
				now.date() == state.date.day &&
				now.month() == state.date.month &&
				now.year() == state.date.year
			) {
				h = now.hour()
			}
			return {...state, time: {...state.time, hour: h}}

		case PLUS_MINUTE:
			var m = ("0" + (Number(state.time.minute) + 10)).slice(-2)
			if (m >= 60) m = "00"
			return {...state, time: {...state.time, minute: m}}

		case MINUS_MINUTE:
			var m = Number(state.time.minute) - 10
			if (m < "0") m = "50"
			m = ("0" + m).slice(-2)
			return {...state, time: {...state.time, minute: m}}

		case ORIGIN_LOCATION_SELECTED:
			return {
				...state,
				destinationMarkerOpacity: 1,
				originMarkerDraggable: false,
				map: {
					...state.map,
					zoom: 16,
					center: {
						...state.map.center,
						lat: state.map.marker.lat + 1 / (state.map.zoom * 30),
						lng: state.map.marker.lng,
					},
					markerTo: {
						...state.map.markerTo,
						lat: state.map.marker.lat + 1 / (state.map.zoom * 30),
						lng: state.map.marker.lng,
					},
				},
				order: {
					...state.order,
					startAddressLat: action.latlng.lat,
					startAddressLong: action.latlng.lng,
					// startAddress: action.address,
				},
			}

		case DESTINATION_LOCATION_SELECTED:
			return {
				...state,
				locatingDone: true,
				destinationMarkerDraggable: false,
				order: {
					...state.order,
					destinationMarkerDraggable: false,
					endAddressLat: action.latlng.lat,
					endAddressLong: action.latlng.lng,
					endAddress: action.address,
				},
			}

		case SEARCH_SELECTED:
			return {
				...state,
				map: {
					...state.map,
					zoom: 17,
					center: {
						lat: action.value[0],
						lng: action.value[1],
					},
				},
			}

		case RESET_DESTINATION:
			return {
				...state,
				destinationMarkerDraggable: true,
				locatingDone: false,
				order: {
					...state.order,
					endAddress: "",
					endAddressLat: "",
				},
			}

		case CHANGE_ORIGIN_ADDRESS:
			return {...state, order: {...state.order, startAddress: action.address}}
		case CHANGE_DESTINATION_ADDRESS:
			return {...state, order: {...state.order, endAddress: action.address}}

		case PLUS_ORIGIN_FLOOR:
			var floor =
				state.order.origin_floor !== "" ? state.order.origin_floor + 1 : 0
			return {...state, order: {...state.order, origin_floor: floor}}

		case MINUS_ORIGIN_FLOOR:
			var floor =
				state.order.origin_floor !== "" ? state.order.origin_floor - 1 : 0

			if (state.order.origin_floor === 0) return state

			return {...state, order: {...state.order, origin_floor: floor}}

		case PLUS_DESTINATION_FLOOR:
			var floor =
				state.order.destination_floor !== ""
					? state.order.destination_floor + 1
					: 0
			return {...state, order: {...state.order, destination_floor: floor}}

		case MINUS_DESTINATION_FLOOR:
			var floor = state.order.destination_floor
				? state.order.destination_floor - 1
				: 0

			if (state.order.destination_floor === 0) return state
			return {...state, order: {...state.order, destination_floor: floor}}

		case UPDATE_ORIGIN_LATLNG:
			return {
				...state,
				map: {
					...state.map,
					marker: action.latlng,
					zoom: action.zoom,
					current: action.latlng,
				},
			}
		case UPDATE_DESTINATION_LATLNG:
			return {
				...state,
				map: {
					...state.map,
					markerTo: action.latlng,
					zoom: action.zoom,
					current: action.latlng,
				},
			}

		case SHOW_ERROR_ALERT:
			return {
				...state,
				errorAlert: true,
				errorMessage: action.message,
				inProgress: false,
			}
		case HIDE_ERROR_ALERT:
			return {...state, errorAlert: false}

		case SHOW_SUCCESS_ALERT:
			return {...state, successAlert: true, successAlertMessage: action.message}
		case HIDE_SUCCESS_ALERT:
			return {...state, successAlert: false}

		case CHANGE_COUPON:
			return {
				...state,
				wrongCoupon: false,
				order: {...state.order, discount_code: action.coupon},
			}

		case WRONG_COUPON:
			state = {...state, order: {...state.order, discount_code: ""}}
			const {discount_code, ...newOrder} = state.order
			return {
				...state,
				wrongCoupon: true,
				couponMessage: action.message,
				order: newOrder,
			}

		case CHECK_COUPON:
			return {...state, couponApplied: true, price: action.price}

		case SHOW_ORDER_ALERT:
			return {...state, orderAlert: true, orderAlertMessage: action.message}

		case HIDE_ORDER_ALERT:
			return {...state, orderAlert: false, orderAlertMessage: ""}

		case SHOW_PHONE_ALERT:
			return {...state, phoneAlert: true, phoneAlertMessage: action.message}

		case HIDE_PHONE_ALERT:
			return {...state, phoneAlert: false, phoneAlertMessage: ""}

		case CHANGE_RECEIVER_NAME:
			return {...state, receiverName: action.value}

		case CHANGE_RECEIVER_LAST_NAME:
			return {...state, receiverLastName: action.value}

		case CHANGE_RECEIVER_PHONE:
			return {...state, order: {...state.order, receiver_mobile: action.value}}

		case VERIFICATION_CODE_SENT:
			return {...state, inProgress: false, phoneAlert: false}

		case SEND_ORDER:
			if (state.workerPolicyApplied)
				return {
					...state,
					inProgress: false,
					orderId: action.payload.data[0].id,
					orderAlert: false,
					warningAlert: true,
					warningMessage: t("warning.workers-added"),
				}

			return {
				...state,
				inProgress: false,
				orderId: action.payload.data[0].id,
				orderAlert: false,
			}

		case SET_USER_ID:
			return {...state, userId: action.value}

		case GET_ORDER:
			return {...state, oneOrder: action.payload}

		case GET_BILL:
			return {...state, bill: action.payload.data}

		case REMOVE_INVOICE:
			return {...state, bill: undefined, oneOrder: undefined}

		case STRINGIFY_SHIT:
			if (!state.order.vasayeleHazinedar.data)
				return {
					...state,
					order: {
						...state.order,
						vasayeleHazinedar: `${JSON.stringify({
							data: state.order.vasayeleHazinedar,
						})}`,
					},
				}
			else return state

		case CHANGE_ORIGIN_BUILDING_NUM:
			return {...state, originBuildingNum: action.value}

		case CHANGE_DEST_BUILDING_NUM:
			return {...state, destBuildingNum: action.value}

		case HANDLE_BUILDING_NUMS:
			const addrArr = state.order.startAddress.split("،")
			const p = addrArr[addrArr.length - 1]

			if (!p.includes("ﭘﻼﮎ"))
				return {
					...state,
					order: {
						...state.order,
						startAddress:
							state.order.startAddress + "، ﭘﻼﮎ " + state.originBuildingNum,
						endAddress:
							state.order.endAddress + "، ﭘﻼﮎ " + state.destBuildingNum,
					},
				}
			else return state

		case INVOICE_PAYED:
			return {...state, invoicePayed: true}

		case PREPARE_ORDER:
			if (
				state.order.barbar_worker < orderingConfigValues.minWorker &&
				state.order.car_id === orderingConfigValues.truckServiceNumber &&
				(state.order.origin_floor > orderingConfigValues.maxFloor ||
					state.order.destination_floor > orderingConfigValues.maxFloor)
			) {
				return {
					...state,
					workerPolicyApplied: true,
					order: {
						...state.order,
						barbar_worker: orderingConfigValues.minWorker,
						user_id: action.userId,
						platform: "webapp",
						receiver_name: `${state.receiverName} ${state.receiverLastName}`,
					},
				}
			}

			return {
				...state,
				order: {
					...state.order,
					user_id: action.userId,
					receiver_name: `${state.receiverName} ${state.receiverLastName}`,
				},
			}

		case SET_DISCOUNT_CHANGES:
			return {
				...state,
				bill: {
					...state.bill,
					price: action.data,
				},
			}

		case SUBMIT_ORDER:
			return {...state, orderSubmitted: true}

		case ORDER_CANCELED:
			return {
				...state,
				bill: {...state.bill, order: {...state.bill.order, status: 7}},
			}

		case RESET_STATE:
			return initialState

		case COPY_RECEIVER_NAME:
			return {
				...state,
				receiverName: action.name,
				receiverLastName: action.lastName,
				order: {...state.order, receiver_mobile: action.phone},
			}

		case SHOW_WARNING_ALERT:
			return {
				...state,
				warningAlert: true,
				warningMessage: action.message,
			}

		case HIDE_WARNING_ALERT:
			return {
				...state,
				warningAlert: false,
			}

		case RESET_RECEIVER:
			return {
				...state,
				receiverName: "",
				receiverLastName: "",
				order: {...state.order, receiver_mobile: ""},
			}

		case CHANGE_ORIGIN_FLOOR:
			return {
				...state,
				order: {...state.order, origin_floor: action.floor},
			}

		case CHANGE_DEST_FLOOR:
			return {
				...state,
				order: {...state.order, destination_floor: action.floor},
			}

		case TOGGLE_ELEVATOR_DEST:
			return {
				...state,
				order: {...state.order, asansor_dest: !state.order.asansor_dest},
			}

		case TOGGLE_ELEVATOR_ORIGIN:
			return {
				...state,
				order: {...state.order, asansor_origin: !state.order.asansor_origin},
			}

		case CHANGE_RECEIVER_DISPLAY:
			return {...state, showReceiver: action.display}

		case RETRIEVE_INVOICE_LIST:
			return {
				...state,
				invoiceList: action.list,
				invoiceListCurrentPage: action.page,
			}

		case REMOVE_INVOICE_LIST:
			return {...state, invoiceList: undefined, invoiceListCurrentPage: 1}

		case IS_SELECTING_LOCATION:
			return {...state, isSelectingLocation: true}

		case LOCATION_SELECTED:
			return {...state, isSelectingLocation: false}

		case START_CHECKING_FOR_COMMENT:
			return {...state, checkingForComment: true}

		case END_CHECKING_FOR_COMMENT:
			return {...state, checkingForComment: false}

		case SET_ORDER_ID:
			return {...state, id: action.id}

		case SET_SERVICE_STATUS:
			return {...state, order: {...state.order, status: action.status}}

		case SET_MORE_SERVICES_ORDER:
			return {
				...state,
				price: null,
				order: {...state.order, barbar_worker: 0, vasayeleHazinedar: []},
			}

		case SET_EDITING_ORDER:
			return {...state, order: action.order}

		case SET_SEARCH_PLACE_RESULT:
			return {...state, searchResult: action.value}

		case INCREASE_STOP_TIME:
			return {
				...state,
				order: {
					...state.order,
					stop_inway:
						state.order.stop_inway + orderingConfigValues.stopTimePeriod,
				},
			}

		case DECREASE_STOP_TIME:
			if (state.order.stop_inway > 0)
				return {
					...state,
					order: {
						...state.order,
						stop_inway:
							state.order.stop_inway - orderingConfigValues.stopTimePeriod,
					},
				}
			else return state

		case INCREASE_WALKING:
			return {
				...state,
				order: {
					...state.order,
					origin_walking:
						state.order.origin_walking + orderingConfigValues.walkingPortion,
				},
			}

		case DECREASE_WALKING:
			if (state.order.origin_walking > 0)
				return {
					...state,
					order: {
						...state.order,
						origin_walking:
							state.order.origin_walking - orderingConfigValues.walkingPortion,
					},
				}
			else return state

		case SET_ADDRESSES:
			return {
				...state,
				order: {
					...state.order,
					startAddress: action.res.origin,
					endAddress: action.res.destination,
				},
			}
		case SET_DRIVER:
			return {...state, driver: action.data}
		case ASYNC_COUPON_START:
			return {...state, asyncCoupon: true}
		case ASYNC_COUPON_END:
			return {...state, asyncCoupon: false}
		case SET_TIMING:
			return {...state, timing: action.data, hours: action.data[0].periods}
			case SET_PRICE_SUBMIT_BUTTON:
			return {...state, priceButtons: action.value}
			case SET_PRICE_SUBMIT_BUTTON_ID:
			return {...state, order: {...state.order, calc_type: action.value}}
		case SET_HOURS:
			return {...state, hours: action.hours}
		case PREORDERING_PROGRESS_START:
			return {...state, preOrdering: true}
		case PREORDERING_PROGRESS_END:
			return {...state, preOrdering: false}
		case SUBMIT_ORDER_AFTER_ALL:
			return {...state, submitOrderAfterALL: action.value}
		case SUBMITTING_ORDER:
			return {...state, submittingOrder: action.value}
		case SET_MARKETING_TOKEN:
			return {
				...state,
				order: {
					...state.order,
					marketer: action.marketer,
					marketer_token: action.token,
				},
			}
		case CHANGE_ORDER_DESCRIPTION:
			return {...state, order: {...state.order, description: action.value}}
		case OPEN_DRAWER_MENU:
			return {...state, openDrawerMenu: true}
		case CLOSE_DRAWER_MENU:
			return {...state, openDrawerMenu: false}
		case SHOW_BACK_BTN:
			return {...state, showBackBtn: true}
		case HIDE_BACK_BTN:
			return {...state, showBackBtn: false}
		case SET_CANCEL_REASON_TEXT:
			return {...state, cancelReason: action.value}
		case SET_CANCEL_TEXTAREA:
			return {...state, cancelTextarea: action.value}
		case SET_SHOW_TIME_CARD:
			return {...state, showTimeCard: action.value}
		case STORE_HEAVY_ITEMS:
			const vasayeleHazinedar = action.value.map((obj) => ({...obj, count: 0}))
			return {...state, order: {...state.order, vasayeleHazinedar}}
		case HIDE_HEADER:
			return {...state, hideHeader: action.value}
		case CHANGE_AREA_VALUE:
			return {...state, order: {...state.order, metraj: action.value}}
		case SET_WORKER_VALUE:
			return {...state, order: {...state.order, barbar_worker: action.value}}

		default:
			return state
	}
}
